import { T } from 'consts/translationKeys'
import { useTimelineContext } from 'context/TimelineContext'
import { dispatch } from 'store'
import { projectDataThunks } from 'store/features/projectData/thunks'
import { translate } from 'utils/translations'
import ActionButton from '../ActionButton'
import SplitIcon from 'assets/svgr-icons/Split.svg'
import { useSelector } from 'react-redux'
import { editorSelectors } from 'store/features/editor/selectors'
import { useCallback } from 'react'

export const SplitButton = () => {
  const { getCurrentTimeImmediate } = useTimelineContext()
  const activeTimelineItems = useSelector(editorSelectors.activeTimelineItems)

  const isDisabled = activeTimelineItems.length > 1

  const handleSplit = useCallback(() => {
    if (isDisabled) {
      return
    }
    const currentTime = getCurrentTimeImmediate()
    dispatch(projectDataThunks.splitTimelineItem(currentTime))
  }, [getCurrentTimeImmediate, isDisabled])

  return (
    <ActionButton
      icon={<SplitIcon />}
      tooltipText={translate(T.SPLIT_LABEL)}
      onClick={handleSplit}
      disabled={isDisabled}
    />
  )
}
